import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GoToHITButtonComponent } from './go-to-hitbutton/go-to-hitbutton.component';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';

@NgModule({
    declarations: [GoToHITButtonComponent],
    exports: [GoToHITButtonComponent],
    imports: [CommonModule, MatButtonModule, MatIconModule, MatTooltipModule],
})
export class GoToHITButtonModule {}
